import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const Amphitheatre = {
  id: '81',
  name: 'Amphitheatre',
  width: 5,
  height: 4,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Amphitheatre',
  minLevel: 1,
  maxLevel: 5,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Amphitheatre',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([400, 550, 750, 1000, 1300]),
      CultureRange.asFlat(4),
    )
  ]),
};

export default Amphitheatre;
